import gql from "graphql-tag";

export default (config) => {
  const { client } = config;

  return {
    analyze: async ({ period_days = 365 }) => {
      const query = gql`
        query($period_days: Int!) {
          items: fn_stock_optimization_analysis(
            args: { v_period_days: $period_days }
          ) {
            item_id
            item_code
            item_description
            current_stock_value
            stock_value_ordered
            stock_value_needed
            current_max_stock_value
            current_reorder_stock_value
            avg_monthly_sales
            lead_time_days
            suggested_max_stock_value
            suggested_reorder_stock_value
            change_needed
            change_amount
            supplier_account_id
            supplier_company_name
          }
        }
      `;
      const {
        data: { items },
      } = await client.query({
        query,
        variables: { period_days },
        fetchPolicy: "network-only",
      });
      return items;
    },

    applyUpdates: async (updates) => {
      const mutation = gql`
        mutation($updates: jsonb!) {
          result: fn_update_stock_values(args: { v_updates: $updates }) {
            updated_count
            success
          }
        }
      `;
      const {
        data: { result },
      } = await client.mutate({
        mutation,
        variables: { updates },
      });
      // Function returns array with one element, extract it
      return result && result.length > 0
        ? result[0]
        : { updated_count: 0, success: false };
    },
  };
};
